import dayjs from 'dayjs';
import React, { useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { ReactComponent as GraphHoverIcon } from '../../assets/icons/graph-hover-icon.svg';
import { ReactComponent as GraphActiveIcon } from '../../assets/icons/graph-icon-active.svg';
import { ReactComponent as GraphIcon } from '../../assets/icons/graph-icon.svg';
import { ReactComponent as MoreIcon } from '../../assets/icons/more-icon.svg';
import { ReactComponent as ReportsTableActiveIcon } from '../../assets/icons/textalign-justifycenter-active.svg';
import { ReactComponent as ReportsTableHoverIcon } from '../../assets/icons/textalign-justifycenter-hover-icon.svg';
import { ReactComponent as ReportsTableIcon } from '../../assets/icons/textalign-justifycenter.svg';
import ThemeContext from '../../contexts/theme-context/ThemeContext';
// import { ReportsInterFace } from '../../interface/report-management.interface';
// import { RequestReportInterFace } from '../../interface/reportAlertsPoint.interface';
import { AccountsInterFace } from '../../interface/account-management.interface';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
// import { setNotificationMessage } from '../../redux/slices/NotificationManagementSlice';
import { fetchAllAccountsId } from '../../redux/slices/AccountManagementSlice';
import { setNotificationMessage } from '../../redux/slices/NotificationManagementSlice';
import { setPageTitle } from '../../redux/slices/PageTitleSlice';
import { setBookingPointReportUpdate } from '../../redux/slices/ReportBookingPointSlice';
import { setBookingStationReportUpdate } from '../../redux/slices/ReportBookingStationSlice';
import { setChargerPointReportUpdate } from '../../redux/slices/ReportChargerPointSlice';
import { setChargerStationReportUpdate } from '../../redux/slices/ReportChargerStationSlice';
import { setEnergyPointReportUpdate } from '../../redux/slices/ReportEnergyPointSlice';
import { setEnergyStationReportUpdate } from '../../redux/slices/ReportEnergyStationSlice';
import { setMaintenancePointReportUpdate } from '../../redux/slices/ReportMaintenancePointSlice';
import { setMaintenanceStationReportUpdate } from '../../redux/slices/ReportMaintenanceStationSlice';
// import { fetchAllReports } from '../../redux/slices/ReportManagementSlice';
import { setPerformancePointReportUpdate } from '../../redux/slices/ReportPerformancePointSlice';
import { setPerformanceStationReportUpdate } from '../../redux/slices/ReportPerformanceStationSlice';
import { setRevenuePointReportUpdate } from '../../redux/slices/ReportRevenuePointSlice';
import { setRevenueStationReportUpdate } from '../../redux/slices/ReportRevenueStationSlice';
import {
  setReportsData,
  resetReportUpdateFlag,
  setAccountId,
  fetchBookMarksList,
} from '../../redux/slices/ReportSlice';
import MyButton from '../../shared-components/button/Button';
import CustomDateRangePicker from '../../shared-components/custom-date-range/CustomDateRangePicker';
import CustomPopover from '../../shared-components/custom-pop-over/CustomPopover';
import TimeRangeDropdown from '../../shared-components/custom-time-range-dropdown/TimeRangeDropdown';
import CustomToggleButton from '../../shared-components/custom-toggle-button/CustomToggleButton';
import ModalBox from '../../shared-components/modal-box/ModalBox';
// import PageTitle from '../../shared-components/page-title/PageTitle';
import SelectField from '../../shared-components/select-field/SelectField';
import SuccessNotification from '../../shared-components/success-notification/SuccessNotification';
import { getDateRange } from '../../shared-functions/DateTime';
// import { GetParametersFromCommonFilters } from '../../shared-functions/CommonFilters';
// import { exportCSV, exportPDF } from '../../shared-functions/ExportFile';
import { permissionCheck } from '../../shared-functions/JWTDocodeFunction';
import reportApi from '../../utils/api/reports';

import AlertsReportChart from './components/alertsReport/AlertsReportChart';
import AlertsReportTablePoint from './components/alertsReport/AlertsReportTablePoint';
import AlertsReportTableStation from './components/alertsReport/AlertsReportTableStation';
import BookingReportDurationChart from './components/bookingreport/BookingReportDurationChart';
import BookingReportTablePoint from './components/bookingreport/BookingReportTablePoint';
import BookingReportTableStation from './components/bookingreport/BookingReportTableStation';
import BookingReportTrendChart from './components/bookingreport/BookingReportTrendChart';
import BookmarkOption from './components/BookmarkOption';
import ChargerReportChart from './components/chargerUtilizationReport/ChargerReportChart';
import ChargerReportRevenue from './components/chargerUtilizationReport/ChargerReportRevenueChart';
import ChargerReportTablePoint from './components/chargerUtilizationReport/ChargerReportTablePoint';
import ChargerReportTableStation from './components/chargerUtilizationReport/ChargerReportTableStation';
import EnergyReportDurationChart from './components/energyreport/EnergyReportDurationChart';
import EnergyReportRevenue from './components/energyreport/EnergyReportRevenueChart';
import EnergyReportTablePoint from './components/energyreport/EnergyReportTablePoint';
import EnergyReportTableStation from './components/energyreport/EnergyReportTableStation';
import EnergyReportTrendChart from './components/energyreport/EnergyReportTrendChart';
import MaintenanceReportChart from './components/MaintenanceReport/MaintenanceReportChart';
import MaintenanceReportRevenue from './components/MaintenanceReport/MaintenanceReportRevenueChart';
import MaintenanceReportTablePoint from './components/MaintenanceReport/MaintenanceReportTablePoint';
import MaintenanceReportTableStation from './components/MaintenanceReport/MaintenanceReportTableStation';
import PerformanceReportChart from './components/performanceReport/PerformanceReportChart';
import PerformanceReportTablePoint from './components/performanceReport/PerformanceReportTablePoint';
import PerformanceReportTableStation from './components/performanceReport/PerformanceReportTableStation';
import RevenueReportDurationChart from './components/revenuereport/RevenueReportDurationChart';
import RevenueReportRevenue from './components/revenuereport/RevenueReportRevenueChart';
import RevenueReportTablePoint from './components/revenuereport/RevenueReportTablePoint';
import RevenueReportTableStation from './components/revenuereport/RevenueReportTableStation';
import RevenueReportTrendChart from './components/revenuereport/RevenueReportTrendChart';


interface ReportData {
  reportByType: string;
  startDate: string;
  endDate: string;
  year?: string;
}

interface ModalBoxDetail {
  title: string | null;
  header: boolean;
  content: JSX.Element | null;
  notificationModal: boolean;
  rightCorner: string;
}

const PAGE_TO_TAB: Record<string, number> = {
  'energy-report': 0,
  'revenue-report': 1,
  'bookings-report': 2,
  'charger-utilization-report': 3,
  'performance-report': 4,
  'maintenance-report': 5,
};

/**
 * PowerConsumptionChart component renders a bar chart to display power consumption data.
 * @returns {any} - The rendered bar chart component.
 */
function PowerConsumptionChart(): JSX.Element {
  const { t } = useTranslation('report');
  const { page } = useParams<{ page: string }>();
  const { theme } = useContext(ThemeContext);
  const [openTab, setOpenTab] = useState(0);
  const [openTabbleorGraph, setOpenTabbleorGraph] = useState(0);
  const dispatch = useAppDispatch();
  const reportsData = useAppSelector((state) => state.reportData);
  const { accountIds = [] } = useAppSelector((state) => state.accounts);
  const { filters: energyReportFilter } = useAppSelector((state) => state.reportEnergyStation);
  const { filters: revenueReportFilter } = useAppSelector((state) => state.reportRevenueStation);
  const { filters: bookingReportFilter } = useAppSelector((state) => state.reportBookingStation);
  const { filters: chargerReportFilter } = useAppSelector((state) => state.reportChargerStation);
  const { filters: performanceReportFilter } = useAppSelector(
    (state) => state.reportPerformanceStation,
  );
  const { filters: maintenanceReportFilter } = useAppSelector(
    (state) => state.reportMaintenanceStation,
  );
  // const { filters: alertsReportFilter } = useAppSelector((state) => state.reportAlertsStation);

  const { filters: energyReportPointFilter } = useAppSelector((state) => state.reportEnergyPoint);
  const { filters: revenueReportPointFilter } = useAppSelector((state) => state.reportRevenuePoint);
  const { filters: bookingReportPointFilter } = useAppSelector((state) => state.reportBookingPoint);
  const { filters: chargerReportPointFilter } = useAppSelector((state) => state.reportChargerPoint);
  const { filters: performanceReportPointFilter } = useAppSelector(
    (state) => state.reportPerformancePoint,
  );
  const { filters: maintenanceReportPointFilter } = useAppSelector(
    (state) => state.reportMaintenancePoint,
  );
  // const { filters: alertsReportPointFilter } = useAppSelector((state) => state.reportAlertsPoint);
  const [modalBoxStatus, setModalBoxStatus] = useState<'open' | 'close'>('close');
  const [selectPreference, setSelectPreference] = useState<string>('');
  const [preferenceFilter, setPreferenceFilter] = useState<any>({});
  const [modalBoxDetail, setModalBoxDetail] = useState<ModalBoxDetail>({
    title: '',
    header: false,
    content: null,
    notificationModal: false,
    rightCorner: '',
  });

  const reportByType = [
    {
      label: t('station'),
      value: 'station',
    },
    {
      label: t('charger'),
      value: 'charger',
    },
  ];

  /**
   * getIcons
   */
  const getIcons = () => ({
    defaultIcons: [
      theme === 'light' ? <ReportsTableIcon /> : <ReportsTableIcon />,
      theme === 'light' ? <GraphIcon /> : <GraphIcon />,
    ],
    activeIcons: [
      theme === 'light' ? (
        <ReportsTableActiveIcon color="white" fill="white" />
      ) : (
        <ReportsTableActiveIcon color="white" fill="white" />
      ),
      theme === 'light' ? (
        <GraphActiveIcon color="white" fill="white" />
      ) : (
        <GraphActiveIcon color="white" fill="white" />
      ),
    ],
    hoverIcons: [
      theme === 'light' ? (
        <ReportsTableHoverIcon color="var(--secondary-color)" fill="var(--secondary-color)" />
      ) : (
        <ReportsTableHoverIcon color="var(--secondary-color)" fill="var(--secondary-color)" />
      ),
      theme === 'light' ? (
        <GraphHoverIcon color="var(--secondary-color)" fill="var(--secondary-color)" />
      ) : (
        <GraphHoverIcon color="var(--secondary-color)" fill="var(--secondary-color)" />
      ),
    ],
  });
  const { defaultIcons, activeIcons, hoverIcons } = getIcons();

  /**
   * Handle the change the page
   * @param {any} index - The index
   */
  const getPageName = (index: number) => {
    console.log(index);
    setOpenTab(index);
    let pageName: string = '';
    let filters: any[] = [];
    switch (index) {
      case 0:
        pageName = 'energy-report';
        filters =
          reportsData.reportByType === 'station'
            ? energyReportFilter
                .filter((filter) => filter.value.length > 0)
                .map((filter) => ({
                  label: filter.name,
                  value: filter.value,
                  field: filter.key,
                }))
            : energyReportPointFilter
                .filter((filter) => filter.value.length > 0)
                .map((filter) => ({
                  label: filter.name,
                  value: filter.value,
                  field: filter.key,
                }));
        break;
      case 1:
        pageName = 'revenue-report';
        filters =
          reportsData.reportByType === 'station'
            ? revenueReportFilter
                .filter((filter) => filter.value.length > 0)
                .map((filter) => ({
                  label: filter.name,
                  value: filter.value,
                  field: filter.key,
                }))
            : revenueReportPointFilter
                .filter((filter) => filter.value.length > 0)
                .map((filter) => ({
                  label: filter.name,
                  value: filter.value,
                  field: filter.key,
                }));
        break;
      case 2:
        pageName = 'bookings-report';
        filters =
          reportsData.reportByType === 'station'
            ? bookingReportFilter
                .filter((filter) => filter.value.length > 0)
                .map((filter) => ({
                  label: filter.name,
                  value: filter.value,
                  field: filter.key,
                }))
            : bookingReportPointFilter
                .filter((filter) => filter.value.length > 0)
                .map((filter) => ({
                  label: filter.name,
                  value: filter.value,
                  field: filter.key,
                }));
        break;
      case 3:
        pageName = 'charger-utilization-report';
        filters =
          reportsData.reportByType === 'station'
            ? chargerReportFilter
                .filter((filter) => filter.value.length > 0)
                .map((filter) => ({
                  label: filter.name,
                  value: filter.value,
                  field: filter.key,
                }))
            : chargerReportPointFilter
                .filter((filter) => filter.value.length > 0)
                .map((filter) => ({
                  label: filter.name,
                  value: filter.value,
                  field: filter.key,
                }));
        break;
      case 4:
        pageName = 'performance-report';
        filters =
          reportsData.reportByType === 'station'
            ? performanceReportFilter
                .filter((filter) => filter.value.length > 0)
                .map((filter) => ({
                  label: filter.name,
                  value: filter.value,
                  field: filter.key,
                }))
            : performanceReportPointFilter
                .filter((filter) => filter.value.length > 0)
                .map((filter) => ({
                  label: filter.name,
                  value: filter.value,
                  field: filter.key,
                }));
        break;
      case 5:
        pageName = 'maintenance-report';
        filters =
          reportsData.reportByType === 'station'
            ? maintenanceReportFilter
                .filter((filter) => filter.value.length > 0)
                .map((filter) => ({
                  label: filter.name,
                  value: filter.value,
                  field: filter.key,
                }))
            : maintenanceReportPointFilter
                .filter((filter) => filter.value.length > 0)
                .map((filter) => ({
                  label: filter.name,
                  value: filter.value,
                  field: filter.key,
                }));
        break;
      // case 6:
      //   pageName = 'alertsReport';
      //   filters =
      //     reportsData.reportByType === 'station'
      //       ? alertsReportFilter
      //           .filter((filter) => filter.value.length > 0)
      //           .map((filter) => ({
      //             label: filter.name,
      //             value: filter.value,
      //             field: filter.key,
      //           }))
      //       : alertsReportPointFilter
      //           .filter((filter) => filter.value.length > 0)
      //           .map((filter) => ({
      //             label: filter.name,
      //             value: filter.value,
      //             field: filter.key,
      //           }));
      //   break;

      default:
        break;
    }
    return {
      entity: pageName,
      filters,
    };
  };

  /**
   * Get the all book marks
   * @param {any} name - The name
   */
  const getAllBookMarks = (name: string) => {
    dispatch(fetchBookMarksList({ entity: name, accountCustomId: reportsData?.accountId }));
  };

  /**
   * Table pagination function
   * @param {any} name - The name
   * @param {any} value - The value
   */
  const handleInputChange = (name: string, value: string | number) => {
    dispatch(setReportsData({ name: name as keyof ReportData, value: String(value) }));
  };

  /**
   * Table pagination function
   * @param {any} name - The name
   * @param {any} value - The value
   */
  const handleSelectFacility = (name: string, value: string | number) => {
    dispatch(setAccountId(String(value)));
    setSelectPreference('');
    const pageName = getPageName(openTab);
    const bookmarkFilter = reportsData.allBookmarks.find(
      (bookmark) => bookmark._id === value,
    )?.filters;
    setPreferenceFilter({
      pageName: pageName.entity,
      filter: bookmarkFilter,
    });
    getAllBookMarks(pageName.entity);
  };

  /**
   * Add Bookmark function
   * @param {any} bookMarkName - The bookMarkName
   */
  const addBookmark = (bookMarkName: string | number) => {
    const pageName = getPageName(openTab);
    const request = {
      name: bookMarkName,
      accountCustomId: reportsData?.accountId,
      ...pageName,
    };
    reportApi
      .addBookMark(request)
      .then(() => {
        getAllBookMarks(pageName.entity);
        setModalBoxDetail({
          title: '',
          header: false,
          rightCorner: '',
          content: (
            <SuccessNotification
              title={t('bookmarkAddedSuccessfully')}
              description=""
              notificationCloseTimer={3000}
              onNotificationClose={() => {
                setModalBoxStatus('close');
              }}
            />
          ),
          notificationModal: true,
        });
      })
      .catch((error) => {
        dispatch(
          setNotificationMessage({
            status: true,
            message: error.message,
            type: 'error',
            code: 0,
          }),
        );
      });
  };

  /**
   * Handle the openAddFacilityModal function
   */
  const openAddVlbcModal = () => {
    setModalBoxDetail({
      title: t('saveBookmark'),
      content: (
        <BookmarkOption
          addBookmark={addBookmark}
          close={() => {
            setModalBoxStatus('close');
          }}
        />
      ),
      notificationModal: false,
      header: true,
      rightCorner: '',
    });
    setModalBoxStatus('open');
  };
  /**
   * Handling select field changes bookmark
   * @param {any} name - The name
   * @param {any} value - The value
   */
  const handleSelectChange = (name: string, value: string) => {
    const pageName = getPageName(openTab);
    const bookmarkFilter = reportsData.allBookmarks.find(
      (bookmark) => bookmark._id === value,
    )?.filters;
    setSelectPreference(value);
    setPreferenceFilter({
      pageName: pageName.entity,
      filter: bookmarkFilter,
    });
  };
  /**
   * Handle the change the page and graph
   * @param {any} index - The index
   */
  const changePageHandleandGraph = (index: number) => {
    if (index === 0 && !permissionCheck('cpoReportTableView')) return;
    if (index === 1 && !permissionCheck('cpoReportGraphView')) return;
    setOpenTabbleorGraph(index);
  };

  /**
   * Handle the change the page
   * @param {any} index - The index
   */
  const changePageHandle = (index: number) => {
    setOpenTab(index);
    let pageName = '';
    switch (index) {
      case 0:
        pageName = 'energy-report';
        break;
      case 1:
        pageName = 'revenue-report';
        break;
      case 2:
        pageName = 'bookings-report';
        break;
      case 3:
        pageName = 'charger-utilization-report';
        break;
      case 4:
        pageName = 'performance-report';
        break;
      case 5:
        pageName = 'maintenance-report';
        break;
      // case 6:
      //   pageName = 'alerts-report';
      //   break;

      default:
        break;
    }
    if (reportsData?.accountId) {
      getAllBookMarks(pageName);
    }
    window.history.pushState({}, '', `${pageName}`);
  };

  /**
   * // Create the leftTopContent JSX
   */
  const renderLeftTopContent = () => (
    <div className="left-top-content">
      <SelectField
        inputLabel={t('reportBy')}
        name="reportByType"
        placeholder={t('selectReportBy')}
        selectedValue={reportsData.reportByType}
        options={reportByType}
        onChangeValue={handleInputChange}
      />
      <SelectField
        inputLabel={t('accountName')}
        name="accountId"
        placeholder={t('selectFacility')}
        selectedValue={reportsData.accountId}
        options={accountIds.map((values: AccountsInterFace) => ({
          value: values.accountCustomId ?? '',
          label: values.accountName ?? '',
        }))}
        enableSearch
        onChangeValue={handleSelectFacility}
      />
      <CustomDateRangePicker
        startDate={
          dayjs(reportsData.reportFilter.startDate, 'YYYY-MM-DD').isValid()
            ? reportsData.reportFilter.startDate
            : ''
        }
        endDate={
          dayjs(reportsData.reportFilter.endDate, 'YYYY-MM-DD').isValid()
            ? reportsData.reportFilter.endDate
            : ''
        }
        placeholder="DD-MMM-YYYY"
        onChange={(start, end) => {
          handleInputChange('startDate', start);
          handleInputChange('endDate', end);
        }}
      />
      <div className="custom-popover-wrapper">
        <CustomPopover
          clickableElement={
            <div className="custom-popover-button">
              <MyButton buttonType="none" label="" onClickFunc={() => {}} svgIcon={<MoreIcon />} />
            </div>
          }
          popOverContent={
            <TimeRangeDropdown
              selected={reportsData.reportFilter.year || ''}
              onSelect={(value: string) => {
                const { startDate, endDate } = getDateRange(value.toLowerCase());

                // Safely format the values
                if (startDate.isValid() && endDate.isValid()) {
                  dispatch(
                    setReportsData({ name: 'startDate', value: startDate.format('YYYY-MM-DD') }),
                  );
                  dispatch(
                    setReportsData({ name: 'endDate', value: endDate.format('YYYY-MM-DD') }),
                  );
                  dispatch(setReportsData({ name: 'year', value }));
                } else {
                  console.error('Invalid startDate or endDate:', startDate, endDate);
                }
              }}
            />
          }
        />
      </div>
    </div>
  );

  useEffect(() => {
    if (reportsData.isReportUpdated) {
      dispatch(setEnergyPointReportUpdate(true));
      dispatch(setEnergyStationReportUpdate(true));
      dispatch(setRevenuePointReportUpdate(true));
      dispatch(setRevenueStationReportUpdate(true));
      dispatch(setBookingStationReportUpdate(true));
      dispatch(setBookingPointReportUpdate(true));
      dispatch(setChargerStationReportUpdate(true));
      dispatch(setChargerPointReportUpdate(true));
      dispatch(setPerformanceStationReportUpdate(true));
      dispatch(setPerformancePointReportUpdate(true));
      dispatch(setMaintenanceStationReportUpdate(true));
      dispatch(setMaintenancePointReportUpdate(true));
      dispatch(resetReportUpdateFlag());
    }
  }, [reportsData.isReportUpdated]);

  useEffect(() => {
    dispatch(setPageTitle(t('reports')));
    dispatch(fetchAllAccountsId());
    switch (page) {
      case 'energy-report':
        changePageHandle(0);
        break;
      case 'revenue-report':
        changePageHandle(1);
        break;
      case 'bookings-report':
        changePageHandle(2);
        break;
      case 'charger-utilization-report':
        changePageHandle(3);
        break;
      case 'performance-report':
        changePageHandle(4);
        break;
      case 'maintenance-report':
        changePageHandle(5);
        break;
      // case 'alerts-report':
      //   changePageHandle(6);
      //   break;

      default:
        break;
    }
  }, []);

  useEffect(() => {
    if (accountIds?.length > 0 && accountIds[0].accountCustomId) {
      dispatch(setAccountId(accountIds[0].accountCustomId));
    }
  }, [accountIds]);

  useEffect(() => {
    if (reportsData?.accountId) {
      const pageName = getPageName(openTab);
      getAllBookMarks(pageName.entity);
    }
  }, [reportsData?.accountId]);

  useEffect(() => {
    const canViewTable = permissionCheck('cpoReportTableView');
    const canViewGraph = permissionCheck('cpoReportGraphView');
    if (!canViewTable && canViewGraph) {
      setOpenTabbleorGraph(1);
    } else if (canViewTable) {
      setOpenTabbleorGraph(0);
    }
  }, []);

  useEffect(() => {
    console.log(page);
    setOpenTab(PAGE_TO_TAB[page as keyof typeof PAGE_TO_TAB] ?? 0);
  }, [page]);

  return (
    <div className="report-chart-wrap">
      <ModalBox
        open={modalBoxStatus === 'open'}
        title={modalBoxDetail.title}
        content={modalBoxDetail.content}
        closeModal={() => setModalBoxStatus('close')}
        notification={modalBoxDetail.notificationModal}
        header={modalBoxDetail.header}
        rightCorner={modalBoxDetail.rightCorner}
        version="v2"
      />
      <div className="report-chart-header">
        <div className="page-title-wrap">
          <div className="tab-graph-container">
            {(permissionCheck('cpoReportTableView') ||
              permissionCheck('cpoReportGraphView')) && (
              <CustomToggleButton
                labels={['', '']}
                onToggle={changePageHandleandGraph}
                activeIndex={openTabbleorGraph}
                icons={defaultIcons}
                activeIcons={activeIcons}
                hoverIcons={hoverIcons}
              />
            )}
          </div>
          <div className="page-title-right-wrap">
            <div className="page-title-rights">
              <div className="top-right-content">
                <SelectField
                  name="selectPreference"
                  options={reportsData.allBookmarks.map((mark) => ({
                    label: mark.name,
                    value: mark._id,
                  }))}
                  selectedValue={selectPreference}
                  onChangeValue={handleSelectChange}
                  placeholder={t('selectPreference')}
                />
              </div>
            </div>
            <div className="page-title-right">
              <MyButton
                label={t('savePreference')}
                buttonType="submit"
                onClickFunc={openAddVlbcModal}
                disableButton={!permissionCheck('cpoReportSavePreferences')}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="report-tabs-container">
        <div className="tab-table-container">
          {/* <CustomToggleButton
            labels={[
              t('energyReport'),
              t('revenueReport'),
              t('bookingsReport'),
              t('chargerUtilizationReport'),
              t('performanceReport'),
              t('maintenanceReport'),
              // t('alertsReport'),
            ]}
            onToggle={changePageHandle}
            activeIndex={openTab}
            version="v2"
          /> */}
        </div>
      </div>
      <div className="table-container">
        {openTab === 0 &&
          (openTabbleorGraph === 0 ? (
            <>
              {reportsData.reportByType === 'station' && (
                <EnergyReportTableStation
                  leftTopContent={renderLeftTopContent()}
                  preferenceFilter={preferenceFilter}
                />
              )}
              {reportsData.reportByType === 'charger' && (
                <EnergyReportTablePoint
                  leftTopContent={renderLeftTopContent()}
                  preferenceFilter={preferenceFilter}
                />
              )}
              <div className="report-chart">
                {reportsData.activePinName &&
                  reportsData.activePinName.includes('powerConsumedByRevenueTyre') && (
                    <EnergyReportRevenue />
                  )}
                {reportsData.activePinName &&
                  reportsData.activePinName.includes('powerConsumedByGuestVsSchedule') && (
                    <EnergyReportDurationChart />
                  )}
                {reportsData.activePinName &&
                  reportsData.activePinName.includes('powerConsumed') && <EnergyReportTrendChart />}
              </div>
            </>
          ) : (
            <div className="report-chart">
              <EnergyReportRevenue />
              <EnergyReportDurationChart />
              <EnergyReportTrendChart />
            </div>
          ))}
        {openTab === 1 &&
          (openTabbleorGraph === 0 ? (
            <>
              {reportsData.reportByType === 'station' && (
                <RevenueReportTableStation
                  leftTopContent={renderLeftTopContent()}
                  preferenceFilter={preferenceFilter}
                />
              )}
              {reportsData.reportByType === 'charger' && (
                <RevenueReportTablePoint
                  leftTopContent={renderLeftTopContent()}
                  preferenceFilter={preferenceFilter}
                />
              )}
              <div className="report-chart">
                {reportsData.activePinName &&
                  reportsData.activePinName.includes('totalRevenue') && <RevenueReportTrendChart />}
                {reportsData.activePinName &&
                  reportsData.activePinName.includes('totalRevenueBySchedule') && (
                    <RevenueReportDurationChart />
                  )}
                {reportsData.activePinName &&
                  reportsData.activePinName.includes('totalRevenueByRevenueTyre') && (
                    <RevenueReportRevenue />
                  )}
              </div>
            </>
          ) : (
            <div className="report-chart">
              <RevenueReportTrendChart />
              <RevenueReportDurationChart />
              <RevenueReportRevenue />
            </div>
          ))}
        {openTab === 2 &&
          (openTabbleorGraph === 0 ? (
            <>
              {reportsData.reportByType === 'station' && (
                <BookingReportTableStation
                  leftTopContent={renderLeftTopContent()}
                  preferenceFilter={preferenceFilter}
                />
              )}
              {reportsData.reportByType === 'charger' && (
                <BookingReportTablePoint
                  leftTopContent={renderLeftTopContent()}
                  preferenceFilter={preferenceFilter}
                />
              )}
              <div className="report-chart">
                {reportsData.activePinName &&
                  reportsData.activePinName.includes('scheduleBooking') && (
                    <BookingReportTrendChart />
                  )}
                {reportsData.activePinName &&
                  reportsData.activePinName.includes('scheduleBookingCompletedVsCanceled') && (
                    <BookingReportDurationChart />
                  )}
              </div>
            </>
          ) : (
            <div className="report-chart">
              <BookingReportTrendChart />
              <BookingReportDurationChart />
            </div>
          ))}
        {openTab === 3 &&
          (openTabbleorGraph === 0 ? (
            <>
              {reportsData.reportByType === 'station' && (
                <ChargerReportTableStation
                  leftTopContent={renderLeftTopContent()}
                  preferenceFilter={preferenceFilter}
                />
              )}
              {reportsData.reportByType === 'charger' && (
                <ChargerReportTablePoint
                  leftTopContent={renderLeftTopContent()}
                  preferenceFilter={preferenceFilter}
                />
              )}
              <div className="report-chart">
                {reportsData.activePinName &&
                  reportsData.activePinName.includes('uptimeVsDowntime') && <ChargerReportChart />}
                {reportsData.activePinName &&
                  reportsData.activePinName.includes('uptimeVsInuse') && <ChargerReportRevenue />}
              </div>
            </>
          ) : (
            <div className="report-chart">
              <ChargerReportChart />
              <ChargerReportRevenue />
            </div>
          ))}
        {openTab === 4 &&
          (openTabbleorGraph === 0 ? (
            <>
              {reportsData.reportByType === 'station' && (
                <PerformanceReportTableStation
                  leftTopContent={renderLeftTopContent()}
                  preferenceFilter={preferenceFilter}
                />
              )}
              {reportsData.reportByType === 'charger' && (
                <PerformanceReportTablePoint
                  leftTopContent={renderLeftTopContent()}
                  preferenceFilter={preferenceFilter}
                />
              )}
              <div className="report-chart">
                {reportsData.activePinName && reportsData.activePinName.includes('performance') && (
                  <PerformanceReportChart />
                )}
              </div>
            </>
          ) : (
            <div className="report-chart">
              <PerformanceReportChart />
            </div>
          ))}
        {openTab === 5 &&
          (openTabbleorGraph === 0 ? (
            <>
              {reportsData.reportByType === 'station' && (
                <MaintenanceReportTableStation
                  leftTopContent={renderLeftTopContent()}
                  preferenceFilter={preferenceFilter}
                />
              )}
              {reportsData.reportByType === 'charger' && (
                <MaintenanceReportTablePoint
                  leftTopContent={renderLeftTopContent()}
                  preferenceFilter={preferenceFilter}
                />
              )}
              <div className="report-chart">
                {reportsData.activePinName &&
                  reportsData.activePinName.includes('maintenanceScheduleStatus') && (
                    <MaintenanceReportRevenue />
                  )}
                {reportsData.activePinName &&
                  reportsData.activePinName.includes('maintenanceScheduleTask') && (
                    <MaintenanceReportChart />
                  )}
              </div>
            </>
          ) : (
            <div className="report-chart">
              <MaintenanceReportRevenue />
              <MaintenanceReportChart />
            </div>
          ))}
        {openTab === 6 &&
          (openTabbleorGraph === 0 ? (
            <>
              {reportsData.reportByType === 'station' && (
                <AlertsReportTableStation
                  leftTopContent={renderLeftTopContent()}
                  preferenceFilter={preferenceFilter}
                />
              )}
              {reportsData.reportByType === 'charger' && (
                <AlertsReportTablePoint
                  leftTopContent={renderLeftTopContent()}
                  preferenceFilter={preferenceFilter}
                />
              )}
              <div className="report-chart">
                {reportsData.activePinName &&
                  reportsData.activePinName.includes('scheduleBooking') && <AlertsReportChart />}
              </div>
            </>
          ) : (
            <div className="report-chart">
              <AlertsReportChart />
            </div>
          ))}
      </div>
    </div>
  );
}

export default PowerConsumptionChart;
